var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { RouteNameEnum } from '@/router/RouteName';
let Offline = class Offline extends Vue {
    async onClickReload() {
        await Promise.all([
            this.$store.dispatch('setIsLoading', true),
            this.$store.dispatch('setApiOffline', false),
        ]);
        this.$router.push({ name: RouteNameEnum.HOME }).catch((_error) => { });
    }
};
Offline = __decorate([
    Component({
        components: {
            LanguageSwitch,
        },
    })
], Offline);
export default Offline;
